import styled from 'styled-components';
import SeH004B from 'dc/SeH004B';
import Wra16A from 'dc/Wra16A';
import ChStPrt7 from 'dc/ChStPrt7';

export const Wrapper = styled.div`
  width: 672px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: stretch;
  border-radius: 4px;
`;

export const Header = styled(SeH004B)`
  background-color: #f4f7f9;
`;

export const NumberWrapper = styled(Wra16A)`
  text-align: left;
  border-bottom: 1px solid rgba(38, 50, 56, 0.12);
  background-color: #fff;
`;

export const StatsContainer = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #fff;
  padding-bottom: 16px;
  border-radius: 0 0 4px 4px;
`;

export const ActivityBubbles = styled(ChStPrt7)`
  width: 100%;
`;
